import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d72076c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
  for: "file_input"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_5 = { for: "date" }
const _hoisted_6 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_7 = { class: "w-full mt-2" }
const _hoisted_8 = { for: "confidentiality" }
const _hoisted_9 = { value: "foto" }
const _hoisted_10 = { value: "Video" }
const _hoisted_11 = { value: "registrazione" }
const _hoisted_12 = { value: "esamistrumentali" }
const _hoisted_13 = { value: "dicom" }
const _hoisted_14 = { value: "documento" }
const _hoisted_15 = { value: "kardia" }
const _hoisted_16 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_17 = { style: {"margin=top":"2%"} }
const _hoisted_18 = { style: {"margin-top":"2%"} }
const _hoisted_19 = {
  key: 0,
  for: "confidenzialità"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_22 = { class: "flex justify-between" }

import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { TagMedicalSpecialty } from "@/../../EshJSLib/models/patient";


export default /*#__PURE__*/_defineComponent({
  __name: 'esamiFiles',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const reader = new FileReader();
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const store = patientStore();
const link = ref('');
const { patient } = storeToRefs(store);
let filenew = ref({} as any);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
let isOpen = ref(false);
const mandatoryFields = ['file', 'created_at', 'file_type', 'id_livello_confidenzialita'];
let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";

onMounted(() => {
  errors.value = [];  
  initFlowbite();
});



function openModal(message: string, file: any): Promise<boolean> {
  errors.value = [];  
  filenew.value = file;
  alertConfirmMessage.value = message;
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });

}

function readFile($event) {
    const file = $event.target.files[0];
    link.value = URL.createObjectURL($event.target.files[0]);
    const blob = new Blob([file], { type: file.type })
    reader.readAsDataURL(blob);
    reader.onload = () => {
      filenew.value.file = reader.result;
    }
    reader.onerror = () => {
    };
    filenew.value.file_nome = $event.target.files[0].name;
    filenew.value.file_size = $event.target.files[0].size / 1000000;
    filenew.value.file_type = $event.target.files[0].type;
  }

  function checkAll($event) {
    if ($event.target.checked) {
      filenew.value.tags = tagsToArray();
    } else {
      filenew.value.tags = [];
    }
  }

  function tagsToArray() {
  let tagsArray = []; let i = 0;
  for(let tag of patient.value.tag_medical_specialties) {
    tagsArray[i++] = tag.id;
  }
  console.log(tagsArray);
  return tagsArray;
}

  function checkTag($event, tag: TagMedicalSpecialty) {
    let tagArray = [];
    if (filenew.value.tags.length != 0) {
      tagArray = filenew.value.tags;
    }
    if ($event.target.checked) {
      tagArray = tagArray.concat(tag.id);
    } else {
      tagArray = tagArray.filter(tagItem => tagItem != tag.id);
    }
    filenew.value.tags = tagArray;
  
  }


function saveTheFile() {

  if( !validateFields() )   {   
      return;    
      }
  alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then((userInput) => {
    if (userInput) {
      showConfirm.value = false;
      if (!resolvePromise) return;
         resolvePromise(true);
    }
  });

}

function validateFields(): boolean {
  let hasError = false;
  errors.value = [];
 
  mandatoryFields.forEach((field, index) => {
   
    if (!filenew.value[field]) {
      console.log(field);
      console.log(errors);
      hasError = true;
    
      errors.value.push(errorMessage);
    }
    else {
      errors.value.push("");

    }
  });

  if (hasError) {
    return false;
  }
  return true;
}




function closeModal() {
  store.fetchEsami();
  store.fetchFiles();
  showConfirm.value = false
  if (!resolvePromise) return;
         resolvePromise(false);
  emit("cancel");
  
}

__expose({ openModal });


return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "3xl",
        onClose: closeModal
      }, {
        header: _withCtx(() => [
          _createVNode(AlertModal, {
            ref_key: "alertModal",
            ref: alertModal
          }, null, 512),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("Crea File")), 1)
        ]),
        body: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("input", {
            onChange: _cache[0] || (_cache[0] = ($event: any) => (readFile($event))),
            class: "block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400",
            id: "file_input",
            type: "file"
          }, null, 32),
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errors)[0]), 1),
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Data rilievo")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filenew).created_at) = $event)),
            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          }, null, 512), [
            [_vModelText, _unref(filenew).created_at]
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(errors)[1]), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("file tipo")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "confidentiality",
              name: "confidentiality",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filenew).type) = $event)),
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"])
            }, [
              _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("Foto")), 1),
              _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t("Video")), 1),
              _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("Registrazione")), 1),
              _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("Video Esami Strumentali")), 1),
              _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("Immagine Dicom")), 1),
              _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("Documento")), 1),
              _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("Kardia")), 1)
            ], 2), [
              [_vModelSelect, _unref(filenew).type]
            ]),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(errors)[2]), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("Note")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filenew).file_commento) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            }, null, 512), [
              [_vModelText, _unref(filenew).file_commento]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_unref(filenew).id_file == null)
              ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("select", {
              id: "confidenzialità",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filenew).id_livello_confidenzialita) = $event)),
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.id_livello_confidenzialita,
                  key: key
                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_20))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(filenew).id_livello_confidenzialita]
            ]),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(errors)[3]), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              onClick: closeModal,
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t("Annulla")), 1),
            _createElementVNode("button", {
              onClick: saveTheFile,
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t("Invia")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})